import type { AccountKey, MailboxInfo } from "owa-client-types";
import { isSameCoprincipalAccountByMailboxAndAccountKey } from "owa-client-types";
import getAccountSourceListStore from "../store/accountSourceListStore";

/**
 * Returns the coprincipal account based on the account key for the mailbox
 * @param accountKey The account key that identifies the account
 * @returns MailboxInfo if a account is the specified account key if found or undefined
 */
export default function getMailboxInfoByAccountKey(accountKey: AccountKey): MailboxInfo | undefined {
    return getAccountSourceListStore().sources.filter(account => isSameCoprincipalAccountByMailboxAndAccountKey(account.mailboxInfo, accountKey))[0]?.mailboxInfo;
}
